import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/user-logs/UserLogsAction";
import * as uiHelpers from "../UserLogsUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useUserLogsUIContext } from "../UserLogsUIContext";

export function UserLogsTable() {
  // User Logs UI Context
  const userLogsUIContext = useUserLogsUIContext();
  const userLogsUIProps = useMemo(() => {
    return {
      queryParams: userLogsUIContext.queryParams,
      setQueryParams: userLogsUIContext.setQueryParams,
      openExceptionModal: userLogsUIContext.openExceptionModal
    };
  }, [userLogsUIContext]);

  // Getting curret state of User Logs list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userLogs }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // User Logs Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getUserLogs(userLogsUIProps.queryParams));
    return () => dispatch(actions.cleanUserLogsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLogsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "schoolName",
      text: "Okul Adı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "userName",
      text: "Kullanıcı Adı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "userTypeName",
      text: "Kullanıcı Türü",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "ipAddress",
      text: "Kullanıcı IP",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "controllerName",
      text: "Controller",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "actionName",
      text: "Actıon",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "path",
      text: "Path",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "150px"
      }
    },
    {
      dataField: "actionTime",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "100px"
      }
    },
    {
      dataField: "method",
      text: "Metod",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "100px"
      }
    },
    {
      dataField: "isSuccess",
      text: "Sonuç",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.ResultColumnFormatter,
      style: {
        minWidth: "100px"
      }
    },
    {
      dataField: "exception",
      text: "Hata",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "250px"
      }
    },
    {
      dataField: "action",
      text: "İşlemler",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openExceptionModal: userLogsUIProps.openExceptionModal
      },
      classes: "text-right pr-1",
      headerClasses: "text-right pr-0",
      style: {
        minWidth: "100px",
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: userLogsUIProps.queryParams.pageSize,
    page: userLogsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                userLogsUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}